import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M9.663 4.227a.75.75 0 0 0-1.017-.914C5.467 4.711 3.25 7.925 3.25 11.66c0 5.008 3.994 9.09 8.947 9.09 3.992 0 7.361-2.653 8.518-6.301a.75.75 0 0 0-1.017-.913 7.3 7.3 0 0 1-2.947.617c-4.1 0-7.447-3.386-7.447-7.59 0-.817.126-1.601.36-2.336M4.75 11.66c0-2.549 1.232-4.8 3.116-6.176a9 9 0 0 0-.062 1.079c0 5.008 3.993 9.09 8.947 9.09q.98-.001 1.902-.206c-1.29 2.277-3.702 3.803-6.456 3.803-4.1 0-7.447-3.386-7.447-7.59m11.58-7.41a.75.75 0 0 0 0 1.5h2.532l-3.33 2.664A.75.75 0 0 0 16 9.75h5a.75.75 0 0 0 0-1.5h-2.862l3.33-2.664A.75.75 0 0 0 21 4.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }